/**
 * learnerEvents — fire-and-forget event emission for learner telemetry.
 *
 * All events are POSTed to /api/scenario-os/learner/events.
 * Failures are silently swallowed so analytics never block the UI.
 *
 * Event types used across the platform:
 *   scene_viewed        — { scene_id, domain, tutorial_id, duration_ms? }
 *   overlay_answered    — { marker_id, is_correct, attempts, time_to_answer_ms }
 *   overlay_skipped     — { marker_id, time_to_answer_ms }
 *   video_paused        — { timestamp_ms }
 *   video_replayed      — { from_ms, to_ms }
 */

export async function emitLearnerEvent(eventData) {
  try {
    const token =
      localStorage.getItem('scenario_os_token') ||
      sessionStorage.getItem('scenario_os_token');
    await fetch('/api/scenario-os/learner/events', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ ...eventData, created_at: new Date().toISOString() }),
    });
  } catch (_e) {
    // fire-and-forget — analytics must never block the UI
  }
}
